// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"698":"5272cc3c","986":"7728005c"}[chunkId] + ".chunk.css";
};